import React, { useState } from "react";
import '../global/GlobalCSS.css';
import ProfileMenu from "./TopbarDropdown/ProfileMenu";
import { Col, Container, Row, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { Link } from "react-router-dom";
import { hasRole } from "utils/auth/authUtils";
import { Roles } from "shared/constants";
import NotificationDropdown from "./TopbarDropdown/NotificationDropdown";
import ESLogo from '../Media/Logo_Horizontal.png';

const Header = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);

  return (
    <React.Fragment>
      <header id="page-topbar">
        <Container fluid>
          <Row>
            <Col sm={5}>
              <Link to="/dashboard">
                <img
                  src={ESLogo}
                  alt="ecoSAIL"
                  height={50}
                  className="vertically-center ps-1"
                />
              </Link>
            </Col>
            <Col sm={{ size: 4, offset: 3 }} className="d-flex justify-content-end align-items-center gap-3">
              <NotificationDropdown />
              {hasRole(Roles.ES_ADMIN) && (
                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                  <DropdownToggle tag="span" className="pointer">
                    <i className="fa fa-cog font-size-20" style={{ cursor: "pointer" }}></i>
                  </DropdownToggle>
                  <DropdownMenu end>
                    <DropdownItem tag={Link} to="/org_config">Organization Settings</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              )}
              <ProfileMenu />
            </Col>
          </Row>
        </Container>
      </header>
    </React.Fragment >
  );
};

export default Header;
